(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-popup"] && !Shopify.designMode) return;
  try {
    
  // Store location (provided latitude and longitude)
const storeLocation = { lat: 24.995255288090483, lng: 55.12975369999999 };
const deliveryRadius = 34; // 34km radius


const specificLocations = [
  "Al Furjan",
  "Discovery Gardens",
  "The Gardens",
  "Jebel Ali Ind Area",
  "Jumeirah Park",
  "Meadows",
  "Greens",
  "JLT",
  "Marina",
  "Palm Jumeirah",
  "JVC",
  "IMPZ",
  "IMPX",
  "Jumeirah Golf Estate",
  "DIP 1",
  "DIP 2",
  "Town Square",
  "Mira Community",
  "Arabian Ranches 1",
  "Arabian Ranches 2",
  "Reem Ram",
  "Dubai Hills",
  "Barsha 1",
  "Barsha 2",
  "Barsha 3",
  "Arjan",
  "JVT",
  "Damac Hills",
  "Tilal Al Ghaf",
  "Expo City",
  "Dubai South",
  "Dubai Silicon Oasis",
  "JAFZA"
];

let map;
let marker;
let geocoder;
let autocompleteService;
let placesService;

// Function to save location data to localStorage
function saveLocationData(locationData) {
  localStorage.setItem('deliveryLocation', JSON.stringify(locationData));
}

// Function to load location data from localStorage
function loadLocationData() {
    const saved = localStorage.getItem('deliveryLocation');
    return saved ? JSON.parse(saved) : null;
}

// Function to clear location data
function clearLocationData() {
    localStorage.removeItem('deliveryLocation');
}

// Function to restore map state from saved data
function restoreMapState() {
    const savedLocation = loadLocationData();
    if (savedLocation && savedLocation.address) {
        // Update the search input
        const searchInput = document.getElementById('searchInput');
        if (searchInput) {
            searchInput.value = savedLocation.address;
        }
        
        // Update all delivery button texts
        updateAllDeliveryButtonTexts(savedLocation.buttonText || "Express Delivery Available");
        
        // If we have coordinates and map is ready, restore the marker
        if (savedLocation.coordinates && map) {
            const location = new google.maps.LatLng(
                savedLocation.coordinates.lat, 
                savedLocation.coordinates.lng
            );
            if (marker) {
                marker.setMap(null); // Remove existing marker
            }
            marker = new google.maps.Marker({
                position: location,
                map: map,
            });
            map.setCenter(location);
            map.setZoom(15);
        }
    }
}

// Initialize the map
function initMap() {
    console.log("Initializing map...");
    const mapElement = document.getElementById('map');
    if (!mapElement) {
        console.error("Map container not found!");
        return;
    }

    map = new google.maps.Map(mapElement, {
        center: storeLocation,
        zoom: 12,
        disableDefaultUI: true,
        gestureHandling: 'greedy',
    });

    geocoder = new google.maps.Geocoder();
    autocompleteService = new google.maps.places.AutocompleteService();
    placesService = new google.maps.places.PlacesService(map);

    // Restore any saved map state
    restoreMapState();

    // Initialize search input
    const input = document.getElementById('searchInput');
    const suggestionsList = document.getElementById('suggestions');

    if (input && suggestionsList) {
        input.addEventListener("input", function () {
            let query = input.value.trim();
            if (query.length < 1) {
                suggestionsList.innerHTML = "";
                suggestionsList.style.display = "none";
                return;
            }

            let request = {
                input: query,
                types: ["geocode", "establishment"],
                componentRestrictions: { country: "AE" }
            };

            autocompleteService.getPlacePredictions(request, function (predictions, status) {
                if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                    suggestionsList.innerHTML = "";
                    suggestionsList.style.display = "none";
                    return;
                }

                suggestionsList.innerHTML = "";
                predictions.forEach(place => {
                    let listItem = document.createElement("li");
                    listItem.textContent = place.description;
                    listItem.onclick = function () {
                        input.value = place.description;
                        suggestionsList.innerHTML = "";
                        suggestionsList.style.display = "none";
                        // Geocode the selected place and mark it on the map
                        geocoder.geocode({ address: place.description }, function(results, status) {
                            if (status === 'OK' && results[0]) {
                                const location = results[0].geometry.location;
                                if (marker) {
                                    marker.setMap(null); // Remove existing marker
                                }
                                marker = new google.maps.Marker({
                                    position: location,
                                    map: map,
                                });
                                map.setCenter(location);
                                map.setZoom(15);
                                
                                // Clear the delivery message
                                document.getElementById('deliveryMessage').textContent = '';
                            }
                        });
                    };
                    suggestionsList.appendChild(listItem);
                });

                suggestionsList.style.display = "block";
            });
        });

        // Hide suggestions when clicking outside
        document.addEventListener("click", function (event) {
            if (!input.contains(event.target) && !suggestionsList.contains(event.target)) {
                suggestionsList.style.display = "none";
            }
        });
    }

    // Add custom zoom controls at the bottom-right corner
    const zoomControlDiv = document.createElement('div');
    zoomControlDiv.classList.add('custom-zoom-controls');
    zoomControlDiv.style.position = 'absolute';
    zoomControlDiv.style.bottom = '15px';
    zoomControlDiv.style.right = '10px';
    zoomControlDiv.style.backgroundColor = 'white';
    zoomControlDiv.style.border = '1px solid #ccc';
    zoomControlDiv.style.borderRadius = '3px';
    zoomControlDiv.style.padding = '5px';
    zoomControlDiv.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.3)';

    const zoomInButton = document.createElement('button');
    zoomInButton.textContent = '+';
    zoomInButton.style.padding = '5px 10px';
    zoomInButton.style.marginBottom = '5px';
    zoomInButton.style.cursor = 'pointer';
    zoomInButton.addEventListener('click', () => map.setZoom(map.getZoom() + 1));

    const zoomOutButton = document.createElement('button');
    zoomOutButton.textContent = '-';
    zoomOutButton.style.padding = '5px 10px';
    zoomOutButton.style.cursor = 'pointer';
    zoomOutButton.addEventListener('click', () => map.setZoom(map.getZoom() - 1));

    zoomControlDiv.appendChild(zoomInButton);
    zoomControlDiv.appendChild(zoomOutButton);

    // Add the zoom controls to the map
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlDiv);

    // Add a marker when the user clicks on the map
    map.addListener('click', function(event) {
        if (marker) {
            marker.setMap(null); // Remove existing marker
        }
        marker = new google.maps.Marker({
            position: event.latLng,
            map: map,
        });

        // Clear the delivery message
        document.getElementById('deliveryMessage').textContent = '';

        // Reverse geocode to get the address
        geocoder.geocode({ location: event.latLng }, function(results, status) {
            if (status === 'OK' && results[0]) {
                document.getElementById('searchInput').value = results[0].formatted_address;
            }
        });
    });
}

// Check if the location is within Dubai
function isInDubai(userLocation) {
    // Approximate bounds of Dubai
    const dubaiBounds = {
        north: 25.3,
        south: 24.8,
        west: 54.8,
        east: 55.6,
    };

    return (
        userLocation.lat >= dubaiBounds.south &&
        userLocation.lat <= dubaiBounds.north &&
        userLocation.lng >= dubaiBounds.west &&
        userLocation.lng <= dubaiBounds.east
    );
}

// Check if the location is within the delivery radius or specific locations
function isDeliveryPossible(address) {
    // Check if the address includes any of the specific locations
    const isSpecificLocation = specificLocations.some(location => address.includes(location));

    if (isSpecificLocation) {
        return true; // 2-hour delivery is possible for specific locations
    }

    // Check if the location is within the 20km radius
    if (marker) {
        const userLocation = { lat: marker.getPosition().lat(), lng: marker.getPosition().lng() };
        return isWithinRadius(userLocation);
    }
    return false;
}

// Check if the location is within the delivery radius
function isWithinRadius(userLocation) {
    const R = 6371; // Earth's radius in km
    const dLat = (userLocation.lat - storeLocation.lat) * (Math.PI / 180);
    const dLng = (userLocation.lng - storeLocation.lng) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(storeLocation.lat * (Math.PI / 180)) *
        Math.cos(userLocation.lat * (Math.PI / 180)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km
    return distance <= deliveryRadius;
}

// Handle location confirmation
function setupConfirmLocationButton() {
    const confirmButton = document.getElementById('confirmLocationButton');
    if (confirmButton) {
        // Remove existing event listeners
        confirmButton.replaceWith(confirmButton.cloneNode(true));
        
        // Add new event listener
        document.getElementById('confirmLocationButton').addEventListener('click', function() {
            const address = document.getElementById('searchInput').value;

            if (!address.trim()) {
                document.getElementById('deliveryMessage').textContent = 'Please enter an address or select a location on the map.';
                return;
            }

            // Geocode the user's address
            geocoder.geocode({ address: address }, function(results, status) {
                if (status === 'OK' && results[0]) {
                    const userLocation = {
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng(),
                    };

                    // Save the location data
                    const locationData = {
                        address: address,
                        coordinates: userLocation,
                        buttonText: "2-Hour Delivery to:<br>" + address
                    };
                    saveLocationData(locationData);

                    // Select all delivery buttons
                    const deliveryButtons = document.querySelectorAll('.modal-toggle-btn.checkDeliveryButton');

                    // Check if the location is within Dubai
                    if (!isInDubai(userLocation)) {
                        document.getElementById('deliveryMessage').textContent =
                            "We're sorry, but delivery is currently unavailable outside Dubai.";
                        updateAllDeliveryButtonTexts("Express Delivery Available");
                        clearLocationData();
                        
                        deliveryButtons.forEach(button => {
                            button.classList.remove("available");
                        });
                        return;
                    }

                    // Check if the location is within the radius or specific locations
                    if (isDeliveryPossible(results[0].formatted_address)) {
                        document.getElementById('deliveryMessage').textContent = 'Great news! Express 2-hour delivery is available for your location.';
                        updateAllDeliveryButtonTexts("2-Hour Delivery to:<br>" + address);

                        deliveryButtons.forEach(button => {
                            button.classList.add("available");
                        });

                        // Close the modal
                        document.getElementById('deliver-popup').classList.remove("is-visible");
                        document.body.classList.remove("overflow-stop");
                    } else {
                        document.getElementById('deliveryMessage').textContent = 'Your order will be delivered within 1 to 2 business days.';
                        updateAllDeliveryButtonTexts("Express Delivery Available");
                        clearLocationData();

                        deliveryButtons.forEach(button => {
                            button.classList.remove("available");
                        });
                    }
                } else {
                    document.getElementById('deliveryMessage').textContent = 'We couldn\'t verify your address. Please try again or enter a different location.';
                    updateAllDeliveryButtonTexts("Express Delivery Available");
                    clearLocationData();

                    const deliveryButtons = document.querySelectorAll('.modal-toggle-btn.checkDeliveryButton');
                    deliveryButtons.forEach(button => {
                        button.classList.remove("available");
                    });
                }
            });
        });
    }
}

// Function to update ALL delivery button texts using innerHTML
function updateAllDeliveryButtonTexts(text) {
    const deliveryButtonTexts = document.querySelectorAll('.delivery-button-text');
    deliveryButtonTexts.forEach(element => {
        element.innerHTML = text;
    });
}

// Use current location
function setupCurrentLocationButton() {
    const currentLocationButton = document.getElementById('useCurrentLocation');
    if (currentLocationButton) {
        currentLocationButton.addEventListener('click', function() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function(position) {
                        const userLocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };

                        // Reverse geocode to get the address
                        geocoder.geocode({ location: userLocation }, function(results, status) {
                            if (status === 'OK' && results[0]) {
                                // Update the search input with the formatted address
                                document.getElementById('searchInput').value = results[0].formatted_address;

                                // Add a marker for the current location
                                if (marker) {
                                    marker.setMap(null); // Remove existing marker
                                }
                                marker = new google.maps.Marker({
                                    position: userLocation,
                                    map: map,
                                });

                                // Center the map on the current location
                                map.setCenter(userLocation);
                                map.setZoom(15); // Adjust zoom level for better visibility

                                // Clear the delivery message
                                document.getElementById('deliveryMessage').textContent = '';
                            } else {
                                console.error("Geocoding failed: " + status);
                                document.getElementById('deliveryMessage').textContent = 'Unable to retrieve your address. Please try again.';
                            }
                        });
                    },
                    function(error) {
                        // Handle errors in getting the current location
                        console.error("Geolocation error: " + error.message);
                        document.getElementById('deliveryMessage').textContent = 'Unable to retrieve your location. Please ensure location services are enabled.';
                    }
                );
            } else {
                // Geolocation is not supported by the browser
                document.getElementById('deliveryMessage').textContent = 'Geolocation is not supported by your browser.';
            }
        });
    }
}

// Tooltip functionality
function showTooltip() {
    const tooltip = document.getElementById('tooltip');
    if (tooltip) {
        tooltip.style.display = 'block';
    }
}

function hideTooltip() {
    const tooltip = document.getElementById('tooltip');
    if (tooltip) {
        tooltip.style.display = 'none';
    }
}

// Initialize everything when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
    // Restore button text on page load
    const savedLocation = loadLocationData();
    if (savedLocation && savedLocation.buttonText) {
        updateAllDeliveryButtonTexts(savedLocation.buttonText);
        
        // Add available class to buttons if location was valid
        if (savedLocation.buttonText.includes("2-Hour Delivery")) {
            const deliveryButtons = document.querySelectorAll('.modal-toggle-btn.checkDeliveryButton');
            deliveryButtons.forEach(button => {
                button.classList.add("available");
            });
        }
    }

    // Open modal function
    document.querySelectorAll(".modal-toggle-btn").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            var modalID = this.getAttribute("data-modal-toggle");
            var modal = document.getElementById(modalID);
            if (modal) {
                modal.classList.add("is-visible");
                document.body.classList.add("overflow-stop");
                
                // Initialize map if not already initialized
                if (typeof google !== 'undefined' && google.maps) {
                    if (!map) {
                        initMap();
                    } else {
                        // Restore map state when reopening modal
                        setTimeout(() => {
                            restoreMapState();
                        }, 100);
                    }
                }
                
                // Setup buttons when modal opens
                setTimeout(() => {
                    setupConfirmLocationButton();
                    setupCurrentLocationButton();
                }, 100);
            }
        });
    });

    // Close modal function
    document.querySelectorAll(".modal-close, .modal-overlay").forEach(function (closeEl) {
        closeEl.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelectorAll(".modal").forEach(function (modal) {
                modal.classList.remove("is-visible");
            });
            document.body.classList.remove("overflow-stop");
        });
    });

    // Prevent clicks inside modal-content from closing the modal
    document.querySelectorAll(".modal-wrapper").forEach(function (wrapper) {
        wrapper.addEventListener("click", function (e) {
            e.stopPropagation();
        });
    });

    // Setup buttons on initial load
    setupConfirmLocationButton();
    setupCurrentLocationButton();
});

// Make functions globally accessible
window.initMap = initMap;
window.showTooltip = showTooltip;
window.hideTooltip = hideTooltip;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      if(document.getElementById('SortBy')){
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      }
      else{
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }

    if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('.modal-toggle-btn').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
          e.preventDefault();
          var elementID = this.getAttribute("data-modal-toggle");
          var modal = document.querySelector('.modal#' + elementID);
          modal.classList.toggle('is-visible');
          if (modal.classList.contains('is-visible')) {
              document.body.classList.add('overflow-stop');
          } else {
              document.body.classList.remove('overflow-stop');
          }
      });
  });
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function(closeElement) {
      closeElement.addEventListener("click", function(e) {
          e.preventDefault();
          document.querySelectorAll(".modal").forEach(function(pane) {
              pane.classList.remove("is-visible");
          });
          document.body.classList.remove('overflow-stop');
      });
  });
  document.querySelectorAll('.scrollbar').forEach(function(scrollbar) {
      scrollbar.addEventListener("click", function(e) {
          e.stopPropagation();
      });
  });


   document.addEventListener("DOMContentLoaded", function () {
  // Select modals
  const loginModal = document.querySelector(".modal.customer.login");
  const registerModal = document.querySelector(".modal.customer.register");

  // Select toggle buttons
  const openRegisterBtn = document.querySelector(".modal.customer.login .modal-toggle-btn[data-modal-toggle='register']");
  const openLoginBtn = document.querySelector(".modal.customer.register .modal-toggle-btn[data-modal-toggle='login']");

  if (loginModal && registerModal && openRegisterBtn && openLoginBtn) {
    // Open Register Modal and Close Login Modal
    openRegisterBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!registerModal.classList.contains("is-visible")) {
        registerModal.classList.add("is-visible"); // Open the register modal
      }
      if (loginModal.classList.contains("is-visible")) {
        loginModal.classList.remove("is-visible"); // Close the login modal
      }
    });

    // Open Login Modal and Close Register Modal
    openLoginBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (registerModal.classList.contains("is-visible")) {
        registerModal.classList.remove("is-visible"); // Close the register modal
      }
      if (!loginModal.classList.contains("is-visible")) {
        loginModal.classList.add("is-visible"); // Open the login modal
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
